export const t = {
  reviews: {
    uk: 'Відгуки',
    en: 'Reviews',
    es: 'Opiniones',
    ru: 'Отзывы',
  },
  leave_review: {
    uk: 'Залишити відгук',
    en: 'Leave a review',
    es: 'Dejar una reseña',
    ru: 'Оставить отзыв',
  },
  dishes: {
    uk: 'Страви',
    en: 'Dishes',
    es: 'Platos',
    ru: 'Блюда',
  },
  service: {
    uk: 'Обслуговування',
    en: 'Service',
    es: 'Servicio',
    ru: 'Обслуживание',
  },
  atmosphere: {
    uk: 'Атмосфера',
    en: 'Atmosphere',
    es: 'Ambiente',
    ru: 'Атмосфера',
  },
  menu_not_found: {
    uk: `Меню не знайдено. Перевірте інтернет з'єднання.`,
    en: 'Menu not found',
    es: 'Menú no encontrado',
    ru: 'Меню не найдено. Проверьте подключение к Интернету.',
  },
  have_questions_contact_us: {
    uk: 'Виникли питання? Напишіть нам: ',
    en: 'Have questions? Contact us: ',
    es: '¿Tienes preguntas? Contáctanos: ',
    ru: 'Есть вопросы? Напишите нам: ',
  },
  my_orders: {
    uk: 'Мої замовлення',
    en: 'My Orders',
    es: 'Mis pedidos',
    ru: 'Мои заказы',
  },
  status_ordered: {
    uk: 'В очікуванні',
    en: 'Waiting',
    es: 'Esperando',
    ru: 'В ожидании',
  },
  status_processing: {
    uk: 'Приготування',
    en: 'Cooking',
    es: 'Cocinando',
    ru: 'Приготовление',
  },
  order_status_ordered: {
    uk: 'В очікуванні',
    en: 'Waiting',
    es: 'Esperando',
    ru: 'В ожидании',
  },
  order_status_processing: {
    uk: 'Активне',
    en: 'Active',
    es: 'Activo',
    ru: 'Активно',
  },
  order_status_delivering: {
    uk: 'Доставляється',
    en: 'Being Delivered',
    es: 'En proceso de entrega',
    ru: 'Доставляется',
  },
  order_status_complete: {
    uk: 'Завершено',
    en: 'Completed',
    es: 'Completado',
    ru: 'Завершено',
  },
  delivery_order_status_ordered: {
    uk: 'В очікуванні',
    en: 'Waiting',
    es: 'Esperando',
    ru: 'В ожидании',
  },
  delivery_order_status_processing: {
    uk: 'Приготування',
    en: 'Cooking',
    es: 'Cocinando',
    ru: 'Приготовление',
  },
  delivery_order_status_delivering: {
    uk: 'Доставляється',
    en: 'Being Delivered',
    es: 'En proceso de entrega',
    ru: 'Доставляется',
  },
  delivery_order_status_complete: {
    uk: 'Доставлено',
    en: 'Delivered',
    es: 'Entregado',
    ru: 'Доставлено',
  },
  total: {
    uk: 'Всього',
    en: 'Total',
    es: 'Total',
    ru: 'Всего',
  },
  there_is_nothing: {
    uk: 'Здається, тут ще нічого немає',
    en: 'It seems that there is nothing here yet',
    es: 'Parece que aún no hay nada aquí',
    ru: 'Похоже, здесь еще ничего нет',
  },
  discount: {
    uk: 'Знижка',
    en: 'Discount',
    es: 'Descuento',
    ru: 'Скидка',
  },
  service_charge: {
    uk: 'За обслуговування',
    en: 'Service charge',
    es: 'Cargo por servicio',
    ru: 'За обслуживание',
  },
  promotions: {
    uk: 'Акції',
    en: 'Promotions',
    es: 'Promociones',
    ru: 'Акции',
  },
  reserve_table: {
    uk: 'Забронювати стіл',
    en: 'Reserve Table',
    es: 'Reservar Mesa',
    ru: 'Забронировать стол',
  },
  delivery: {
    uk: 'Доставка',
    en: 'Delivery',
    es: 'Entrega a domicilio',
    ru: 'Доставка',
  },
  in_restaurant: {
    uk: 'В закладі',
    en: 'In Restaurant',
    es: 'En el restaurante',
    ru: 'В заведении',
  },
  awaiting_payment: {
    uk: 'Очікуємо оплату',
    en: 'Awaiting payment',
    es: 'Esperando pago',
    ru: 'Ожидаем оплату',
  },
  repeat_payment: {
    uk: 'Повторити платіж',
    en: 'Repeat payment',
    es: 'Repetir pago',
    ru: 'Повторить платеж',
  },
  order: {
    uk: 'Замовлення',
    en: 'Order',
    es: 'Orden',
    ru: 'Заказ',
  },
  menu: {
    uk: 'Меню',
    en: 'Menu',
    es: 'Carta',
    ru: 'Меню',
  },
  table_reservation: {
    uk: 'Бронювання столу',
    en: 'Table Reservation',
    es: 'Reserva de mesa',
    ru: 'Бронирование стола',
  },
  date: {
    uk: 'Дата',
    en: 'Date',
    es: 'Fecha',
    ru: 'Дата',
  },
  time: {
    uk: 'Час',
    en: 'Time',
    es: 'Hora',
    ru: 'Время',
  },
  number_of_visitors: {
    uk: 'Кількість відвідувачів',
    en: 'Number of visitors',
    es: 'Número de visitantes',
    ru: 'Количество посетителей',
  },
  name: {
    uk: "Ім'я",
    en: 'Name',
    es: 'Nombre',
    ru: 'Имя',
  },
  phone_number: {
    uk: 'Номер телефону',
    en: 'Phone number',
    es: 'Número de teléfono',
    ru: 'Номер телефона',
  },
  my_order: {
    uk: 'Моє замовлення',
    en: 'My Order',
    es: 'Mi Pedido',
    ru: 'Мой заказ',
  },
  delivery_terms: {
    uk: 'Умови доставки та видачі замовлення',
    en: 'Delivery Terms',
    es: 'Términos de Entrega',
    ru: 'Условия доставки и выдачи заказа',
  },
  new_delivery_order: {
    uk: 'Нове замовлення на доставку',
    en: 'New delivery order',
    es: 'Nuevo pedido a domicilio',
    ru: 'Новый заказ на доставку',
  },
  go_to_order: {
    uk: 'Перейти до замовлення',
    en: 'Go to Order',
    es: 'Ir al pedido',
    ru: 'Перейти к заказу',
  },
  pay: {
    uk: 'Сплатити',
    en: 'Pay',
    es: 'Pagar',
    ru: 'Оплатить',
  },
  working_hours: {
    uk: 'Графік роботи',
    en: 'Working Hours',
    es: 'Horario de Trabajo',
    ru: 'График работы',
  },
  closed: {
    uk: 'Зачинено',
    en: 'Closed',
    es: 'Cerrado',
    ru: 'Закрыто',
  },
  send_review: {
    uk: 'Відправити відгук',
    en: 'Send review',
    es: 'Enviar reseña',
    ru: 'Отправить отзыв',
  },
  paid: {
    uk: 'Сплачено',
    en: 'Paid',
    es: 'Pagado',
    ru: 'Оплачено',
  },
  g: {
    uk: 'г',
    en: 'g',
    es: 'g',
    ru: 'г',
  },
  ml: {
    uk: 'мл',
    en: 'ml',
    es: 'ml',
    ru: 'мл',
  },
  pc: {
    uk: 'шт',
    en: 'pc',
    es: 'pc',
    ru: 'шт',
  },
  celery: {
    uk: 'селера',
    en: 'celery',
    es: 'apio',
    ru: 'сельдерей',
  },
  crustacean: {
    uk: 'коропові',
    en: 'crustaceans',
    es: 'crustáceos',
    ru: 'ракообразные',
  },
  eggs: {
    uk: 'яйця',
    en: 'eggs',
    es: 'huevos',
    ru: 'яйца',
  },
  fish: {
    uk: 'риба',
    en: 'fish',
    es: 'pescado',
    ru: 'рыба',
  },
  gluten: {
    uk: 'глютен',
    en: 'gluten',
    es: 'gluten',
    ru: 'глютен',
  },
  lupins: {
    uk: 'люпин',
    en: 'lupins',
    es: 'altramuces',
    ru: 'люпин',
  },
  milk: {
    uk: 'молоко',
    en: 'milk',
    es: 'leche',
    ru: 'молоко',
  },
  mustard: {
    uk: 'гірчиця',
    en: 'mustard',
    es: 'mostaza',
    ru: 'горчица',
  },
  nuts: {
    uk: 'горіхи',
    en: 'nuts',
    es: 'frutos secos',
    ru: 'орехи',
  },
  peanuts: {
    uk: 'арахіс',
    en: 'peanuts',
    es: 'cacahuetes',
    ru: 'арахис',
  },
  sesame: {
    uk: 'кунжут',
    en: 'sesame',
    es: 'sésamo',
    ru: 'кунжут',
  },
  shellfish: {
    uk: 'морепродукти',
    en: 'shellfish',
    es: 'mariscos',
    ru: 'моллюски',
  },
  soya: {
    uk: 'соя',
    en: 'soya',
    es: 'soja',
    ru: 'соя',
  },
  sulphite: {
    uk: 'сульфіт',
    en: 'sulphite',
    es: 'sulfito',
    ru: 'сульфиты',
  },
  allergens: {
    uk: 'Алергени',
    en: 'Allergens',
    es: 'Alergenos',
    ru: 'Аллергены',
  },
  vegetarian: {
    uk: 'Вегетаріанське',
    en: 'Vegetarian',
    es: 'Vegetariano',
    ru: 'Вегетарианское',
  },
  spicy: {
    uk: 'Гостре',
    en: 'Spicy',
    es: 'Picante',
    ru: 'Острое',
  },
  add: {
    uk: 'Додати',
    en: 'Add',
    es: 'Agregar',
    ru: 'Добавить',
  },
  out_of_stock: {
    uk: 'Немає в наявності',
    en: 'Out of stock',
    es: 'Agotado',
    ru: 'Нет в наличии',
  },
  service_charge_plus: {
    uk: '% за обслуговування',
    en: '% for Service',
    es: '% por Servicio',
    ru: '% за обслуживание',
  },
  comment: {
    uk: 'Коментар',
    en: 'Comment',
    es: 'Comentario',
    ru: 'Комментарий',
  },
  thank_you_review: {
    uk: 'Дякуємо!',
    en: 'Thank you!',
    es: '¡Gracias!',
    ru: 'Спасибо!',
  },
  thank_you_review2: {
    uk: 'Ваша думка дуже важлива для нас і допомагає нам покращувати наші послуги.',
    en: 'Your feedback is very important to us and helps us improve our services.',
    es: 'Su opinión es muy importante para nosotros y nos ayuda a mejorar nuestros servicios.',
    ru: 'Ваше мнение очень важно для нас и помогает нам улучшать наши услуги.',
  },
  completed: {
    uk: 'Готово',
    en: 'Done',
    es: 'Listo',
    ru: 'Готово',
  },
  confirm_booking: {
    uk: 'Підтвердити бронювання',
    en: 'Confirm Booking',
    es: 'Confirmar Reserva',
    ru: 'Подтвердить бронирование',
  },
  restaurant_closed: {
    uk: 'На жаль, в цей день ресторан не працює',
    en: 'Unfortunately, the restaurant is closed on this day',
    es: 'Lamentablemente, el restaurante está cerrado en este día',
    ru: 'К сожалению, в этот день ресторан не работает',
  },
  view_working_hours: {
    uk: 'Переглянути графік роботи',
    en: 'View Working Hours',
    es: 'Ver Horario de Trabajo',
    ru: 'Посмотреть график работы',
  },
  sms_confirmation: {
    uk: `Ми відправили СМС з кодом для підтвердження бронювання. Будь ласка, введіть цей код і натисніть кнопку "Підтвердити бронювання".`,
    en: `We have sent an SMS with a confirmation code for your reservation. Please enter this code and press the 'Confirm Booking' button.`,
    es: `Hemos enviado un SMS con un código de confirmación para su reserva. Por favor, ingrese este código y presione el botón 'Confirmar Reserva'.`,
    ru: 'Мы отправили СМС с кодом для подтверждения бронирования. Пожалуйста, введите этот код и нажмите кнопку "Подтвердить бронирование".',
  },
  sms_code: {
    uk: 'СМС-код',
    en: 'SMS Code',
    es: 'Código SMS',
    ru: 'СМС-код',
  },
  booking_completed: {
    uk: 'Готово!',
    en: 'Done!',
    es: '¡Listo!',
    ru: 'Готово!',
  },
  table_booking_unavailable: {
    uk: 'Бронювання столів наразі недоступно',
    en: 'Table booking is currently unavailable',
    es: 'La reserva de mesas no está disponible en este momento',
    ru: 'Бронирование столов на данный момент недоступно',
  },
  open_fiscal_receipt: {
    uk: 'Фіскальний чек',
    en: 'fiscal receipt',
    es: 'Recibo fiscal',
    ru: 'Фискальный чек',
  },
  service_charge_announcement_1: {
    uk: 'До вашого рахунку буде додано ',
    en: '',
    es: 'Se añadirá un cargo del ',
    ru: 'К вашему счету будет добавлено ',
  },
  service_charge_announcement_2: {
    uk: '% вартості за обслуговування. Це дозволяє нам забезпечити вас високоякісним сервісом та незабутнім досвідом. Дякуємо за розуміння та підтримку нашої команди!',
    en: '% service charge will be added to your bill. This allows us to provide you with high-quality service and an unforgettable experience. Thank you for your understanding and support of our team!',
    es: '% por servicio a su factura. Esto nos permite brindarle un servicio de alta calidad y una experiencia inolvidable. ¡Gracias por su comprensión y apoyo a nuestro equipo!',
    ru: '% за обслуживание. Это позволяет нам обеспечить вас высококачественным сервисом и незабываемым опытом. Спасибо за понимание и поддержку нашей команды!',
  },
  delivery_address: {
    uk: 'Адреса доставки',
    en: 'Delivery Address',
    es: 'Dirección de Entrega',
    ru: 'Адрес доставки',
  },
  confirm: {
    uk: 'Підтвердити',
    en: 'Confirm',
    es: 'Confirmar',
    ru: 'Подтвердить',
  },
  order_accepted: {
    uk: 'Дякуємо! Ваше замовлення прийнято.',
    en: 'Thank you! Your order has been accepted.',
    es: '¡Gracias! Su pedido ha sido aceptado.',
    ru: 'Спасибо! Ваш заказ принят.',
  },
  authorization: {
    uk: 'Авторизація',
    en: 'Authorization',
    es: 'Autorización',
    ru: 'Авторизация',
  },
  client: {
    uk: 'Клієнт',
    en: 'Client',
    es: 'Cliente',
    ru: 'Клиент',
  },
  sing_out: {
    uk: 'Вийти',
    en: 'Sing out',
    es: 'Cerrar sesión',
    ru: 'Выйти',
  },
  login: {
    uk: 'Увійти / Зареєструватись',
    en: 'Sign in / Register',
    es: 'Iniciar sesión / Registrarse',
    ru: 'Войти / Зарегистрироваться',
  },
  not_authorized: {
    uk: 'Ви не авторизовані',
    en: 'You are not authorized',
    es: 'No estás autorizado',
    ru: 'Вы не авторизованы',
  },
  profile: {
    uk: 'Профіль',
    en: 'Profile',
    es: 'Perfil',
    ru: 'Профиль',
  },
  restaurant: {
    uk: 'Ресторан',
    en: 'Restaurant',
    es: 'Restaurante',
    ru: 'Ресторан',
  },
  cart: {
    uk: 'Кошик',
    en: 'Cart',
    es: 'Carrito',
    ru: 'Корзина',
  },
  to_order: {
    uk: 'Замовити',
    en: 'Order',
    es: 'Ordenar',
    ru: 'Заказать',
  },
  something_went_wrong: {
    uk: 'Упс, щось пішло не так. Будь ласка, зверніться до нашої підтримки за телефоном: +38 097 682 98 56',
    en: 'Oops, something went wrong. Please contact our support at: +34 685 557 997',
    es: 'Ups, algo salió mal. Por favor, contacte con nuestro soporte al: +34 685 557 997',
    ru: 'Упс, что-то пошло не так. Пожалуйста, обратитесь в нашу поддержку по телефону: +34 685 557 997',
  },
  authenticate_to_manage_orders_and_reviews: {
    uk: 'Для того, щоб мати змогу керувати вашими замовленнями та залишати відгуки, будь ласка, авторизуйтесь',
    en: 'To be able to manage your orders and leave reviews, please authenticate',
    es: 'Para poder gestionar sus pedidos y dejar comentarios, por favor, autentíquese',
    ru: 'Для того, чтобы иметь возможность управлять вашими заказами и оставлять отзывы, пожалуйста, авторизуйтесь',
  },
  menu_unavailable: {
    uk: 'Меню недоступне',
    en: 'Menu unavailable',
    es: 'Menú no disponible',
    ru: 'Меню недоступно',
  },
  qr_menu: {
    uk: 'QR Меню',
    en: 'QR Menu',
    es: 'Menú QR',
    ru: 'QR Меню',
  },
  still_in_cafe: {
    uk: 'Ви ще в закладі?',
    en: 'Are you still at the restaurant?',
    es: '¿Todavía estás en el restaurante?',
    ru: 'Вы еще в заведении?',
  },
  scan_qr_code: {
    uk: 'Будь ласка, зіскануйте QR-код свого столика',
    en: 'Please scan the QR code of your table',
    es: 'Por favor, escanea el código QR de tu mesa',
    ru: 'Пожалуйста, отсканируйте QR-код вашего столика',
  },
  qr_ordering_unavailable: {
    uk: 'Замовлення через QR меню недоступне в цьому ресторані',
    en: 'Ordering through QR menu is not available in this restaurant',
    es: 'La orden a través del menú QR no está disponible en este restaurante',
    ru: 'Заказ через QR меню недоступен в этом ресторане',
  },
};
